import {
  type FileSnapshot,
  type InventoryResource,
  SecurityScanConclusionEnum,
  SecurityScanResultEvidenceTypeEnum,
  type Snapshot,
} from '@repo/api-gw-sdk';

export const hasSecurityIssue = (
  isSecurityScanEnabled: boolean,
  entity: InventoryResource | Snapshot | FileSnapshot
) => {
  return (
    isSecurityScanEnabled &&
    ((entity.securityScan?.conclusion &&
      entity.securityScan.conclusion !== SecurityScanConclusionEnum.Clean) ||
      ('isInfected' in entity && !!entity.isInfected))
  );
};

const EvidenceTypeDisplayNameMapper: Record<
  SecurityScanResultEvidenceTypeEnum,
  { label: string; entity: string; description: string }
> = {
  [SecurityScanResultEvidenceTypeEnum.SuspiciousExtensionDetected]: {
    label: 'File signatures',
    entity: 'file',
    description: 'found with suspicious signatures',
  },
  [SecurityScanResultEvidenceTypeEnum.SuspiciousActivityDetected]: {
    label: 'Moved files',
    entity: 'file',
    description: 'moved and encrypted',
  },
  [SecurityScanResultEvidenceTypeEnum.ModifiedFilesBecameEncrypted]: {
    label: 'File entropy',
    entity: 'file',
    description: 'found with suspicious entropy',
  },
};

export const getEvidenceStrings = (
  evidenceType: SecurityScanResultEvidenceTypeEnum
): { label: string; description: string; entity: string } => {
  return EvidenceTypeDisplayNameMapper[evidenceType] || evidenceType;
};
